import React from 'react';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { withStyles } from '@material-ui/core/styles';
import { Paper, Divider } from '@material-ui/core';
import SwipeableViews from 'react-swipeable-views';
import { withRouter } from 'react-router-dom';
import Toolbar from '@material-ui/core/Toolbar';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import IconButton from '@material-ui/core/IconButton';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import List from '@material-ui/core/List';
import Grid from '@material-ui/core/Grid';
import _ from 'lodash';
import getData from './../../data-services/api';
import Loader from './../../components/CustomLoader';
import client from './../../utils/apolloClient';
import { getUser } from './../../data-services/queries';
import gql from 'graphql-tag';

const styles = (theme) => ({});

class ListTTCApprovalAMMD extends React.Component {
    state = {
        value: 0,
        loading: true,
        trainings: [],
    };

    async componentDidMount() {
        await client
            .query({
                query: gql(getUser),
            })
            .then(({ data }) => {
                this.setState({
                    userData: data.user,
                });
            });
        if (this.state.userData) {
            Promise.all([
                getData(
                    `select id, sfid, name,type,City__c,startdate,publish__c,heroku_id__c, status from salesforce.campaign where status='AMMD Approval' or status='AMMD Rejected' or status='Accounts'`
                ),
            ]).then(([trainingsData, ...data]) => {
                this.setState({
                    trainings: trainingsData.result,
                    loading: false,
                });
            });
        }
    }

    handleChange = (event, value) => {
        this.setState({ value });
    };

    handleChangeIndex = (index) => {
        this.setState({ value: index });
    };

    renderTrainingList = (trainings) => {
        return (
            <Grid container>
                <Grid item xs={12} sm={12}>
                    {trainings.map((training) => {
                        return (
                            <div key={training.sfid}>
                                <List
                                    elevation={2}
                                    onClick={() => {
                                        this.props.history.push({
                                            pathname: '/training',
                                            search: `?id=${training.id}&sfid=${
                                                training.sfid
                                            }&publish__c=${
                                                training.publish__c === 't' ? true : false
                                            }&heroku_id__c=${training.heroku_id__c}`,
                                        });
                                    }}
                                >
                                    <Grid container spacing={8} alignItems="center">
                                        <Grid item xs={8}>
                                            <Typography align="left" variant="body2" component="">
                                                {training.name}
                                            </Typography>
                                            <Typography
                                                align="left"
                                                variant="caption"
                                                component="p"
                                            >
                                                {training.city__c}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <Typography align="left" variant="body1">
                                                {training.status}
                                            </Typography>
                                            <Typography align="left" variant="caption">
                                                {training.startdate}
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </List>
                                <Divider />
                            </div>
                        );
                    })}
                </Grid>
            </Grid>
        );
    };
    render() {
        const { classes } = this.props;
        const { trainings } = this.state;

        const PendingTTC = _.filter(trainings, {
            status: 'AMMD Approval',
            type: 'TTC',
        });
        const PendingETTC = _.filter(trainings, {
            status: 'AMMD Approval',
            type: 'ETTC',
        });
        const PendingKalamilan = _.filter(trainings, {
            status: 'AMMD Approval',
            type: 'Kalamilan',
        });

        const ApprovedTTC = _.filter(trainings, {
            status: 'Accounts',
            type: 'TTC',
        });
        const ApprovedETTC = _.filter(trainings, {
            status: 'Accounts',
            type: 'ETTC',
        });
        const ApprovedKalamilan = _.filter(trainings, {
            status: 'Accounts',
            type: 'Kalamilan',
        });

        const DisapprovedTTC = _.filter(trainings, {
            status: 'AMMD Rejected',
            type: 'TTC',
        });
        const DisapprovedETTC = _.filter(trainings, {
            status: 'AMMD Rejected',
            type: 'ETTC',
        });
        const DisapprovedKalamilan = _.filter(trainings, {
            status: 'AMMD Rejected',
            type: 'Kalamilan',
        });

        return (
            <div>
                <AppBar position="static">
                    <Toolbar>
                        <IconButton
                            className={classes.menuButton}
                            color="inherit"
                            aria-label="Menu"
                            onClick={() => {
                                this.props.history.goBack();
                            }}
                        >
                            <ArrowBackIcon />
                        </IconButton>
                        <Typography variant="title" color="inherit" className={classes.flex}>
                            Trainings
                        </Typography>
                    </Toolbar>
                </AppBar>
                <Paper>
                    <Tabs
                        value={this.state.value}
                        onChange={this.handleChange}
                        indicatorColor="primary"
                        textColor="primary"
                        variant="fullWidth"
                    >
                        <Tab
                            label={
                                'Pending (' +
                                (PendingETTC.length + PendingTTC.length + PendingKalamilan.length) +
                                ')'
                            }
                        />
                        <Tab
                            label={
                                'Approved (' +
                                (ApprovedETTC.length +
                                    ApprovedKalamilan.length +
                                    ApprovedTTC.length) +
                                ')'
                            }
                        />
                        <Tab
                            label={
                                'Rejected (' +
                                (DisapprovedETTC.length +
                                    DisapprovedKalamilan.length +
                                    DisapprovedTTC.length) +
                                ')'
                            }
                        />
                    </Tabs>
                </Paper>

                {this.state.loading ? (
                    <Grid container alignItems="center" justify="center">
                        <Loader type="Audio" color="#00BFFF" height="50" width="50" />
                    </Grid>
                ) : (
                    <SwipeableViews index={this.state.value} onChangeIndex={this.handleChangeIndex}>
                        <div>
                            <div className={classes.root}>
                                <ExpansionPanel expanded={PendingTTC.length > 0 ? true : false}>
                                    <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                                        <Typography className={classes.heading}>
                                            TTC ({PendingTTC.length})
                                        </Typography>
                                    </ExpansionPanelSummary>
                                    <ExpansionPanelDetails>
                                        {this.renderTrainingList(PendingTTC)}
                                    </ExpansionPanelDetails>
                                </ExpansionPanel>
                                <ExpansionPanel expanded={PendingETTC.length > 0 ? true : false}>
                                    <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                                        <Typography className={classes.heading}>
                                            ETTC ({PendingETTC.length})
                                        </Typography>
                                    </ExpansionPanelSummary>
                                    <ExpansionPanelDetails>
                                        {this.renderTrainingList(PendingETTC)}
                                    </ExpansionPanelDetails>
                                </ExpansionPanel>
                                <ExpansionPanel
                                    expanded={PendingKalamilan.length > 0 ? true : false}
                                >
                                    <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                                        <Typography className={classes.heading}>
                                            Kalamilan ({PendingKalamilan.length})
                                        </Typography>
                                    </ExpansionPanelSummary>
                                    <ExpansionPanelDetails>
                                        {this.renderTrainingList(PendingKalamilan)}
                                    </ExpansionPanelDetails>
                                </ExpansionPanel>
                            </div>
                        </div>
                        <div>
                            <div className={classes.root}>
                                <ExpansionPanel expanded={ApprovedTTC.length > 0 ? true : false}>
                                    <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                                        <Typography className={classes.heading}>
                                            TTC ({ApprovedTTC.length})
                                        </Typography>
                                    </ExpansionPanelSummary>
                                    <ExpansionPanelDetails>
                                        {this.renderTrainingList(ApprovedTTC)}
                                    </ExpansionPanelDetails>
                                </ExpansionPanel>
                                <ExpansionPanel expanded={ApprovedETTC.length > 0 ? true : false}>
                                    <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                                        <Typography className={classes.heading}>
                                            ETTC ({ApprovedETTC.length})
                                        </Typography>
                                    </ExpansionPanelSummary>
                                    <ExpansionPanelDetails>
                                        {this.renderTrainingList(ApprovedETTC)}
                                    </ExpansionPanelDetails>
                                </ExpansionPanel>
                                <ExpansionPanel
                                    expanded={ApprovedKalamilan.length > 0 ? true : false}
                                >
                                    <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                                        <Typography className={classes.heading}>
                                            Kalamilan ({ApprovedKalamilan.length})
                                        </Typography>
                                    </ExpansionPanelSummary>
                                    <ExpansionPanelDetails>
                                        {this.renderTrainingList(ApprovedKalamilan)}
                                    </ExpansionPanelDetails>
                                </ExpansionPanel>
                            </div>
                        </div>
                        <div>
                            <div className={classes.root}>
                                <ExpansionPanel expanded={DisapprovedTTC.length > 0 ? true : false}>
                                    <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                                        <Typography className={classes.heading}>
                                            TTC ({DisapprovedTTC.length})
                                        </Typography>
                                    </ExpansionPanelSummary>
                                    <ExpansionPanelDetails>
                                        {this.renderTrainingList(DisapprovedTTC)}
                                    </ExpansionPanelDetails>
                                </ExpansionPanel>
                                <ExpansionPanel
                                    expanded={DisapprovedETTC.length > 0 ? true : false}
                                >
                                    <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                                        <Typography className={classes.heading}>
                                            ETTC ({DisapprovedETTC.length})
                                        </Typography>
                                    </ExpansionPanelSummary>
                                    <ExpansionPanelDetails>
                                        {this.renderTrainingList(DisapprovedETTC)}
                                    </ExpansionPanelDetails>
                                </ExpansionPanel>
                                <ExpansionPanel
                                    expanded={DisapprovedKalamilan.length > 0 ? true : false}
                                >
                                    <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                                        <Typography className={classes.heading}>
                                            Kalamilan ({DisapprovedKalamilan.length})
                                        </Typography>
                                    </ExpansionPanelSummary>
                                    <ExpansionPanelDetails>
                                        {this.renderTrainingList(DisapprovedKalamilan)}
                                    </ExpansionPanelDetails>
                                </ExpansionPanel>
                            </div>
                        </div>
                    </SwipeableViews>
                )}
            </div>
        );
    }
}
export default withRouter(withStyles(styles)(ListTTCApprovalAMMD));
